import { Botao } from "./Botao";

export default Botao;